import { types } from 'mobx-state-tree';

export const ErrorModel = types.maybeNull(
    types.model({
        message: types.maybeNull(types.string),
        status: types.maybeNull(types.number)
    })
);
